<template>
    <div ref="root" class="flex-1 bg-custom-gray-100 rounded-lg border border-custom-gray-100 cursor-pointer focus-border" tabindex="0">
        <Label class="pt-1.5 px-3">{{ $t('How long') }}</Label>
        <MultiSelect size="lg" variant="form" ref="multiSelect" v-model="modelValue" mode="single" :searchable="false" :options="options" label="label" valueProp="value" trackBy="label" :placeholder="$t('Select nights')" :close-on-select="true">
            <template #option="{ option }">
                <Icon v-if="hasAvailableNights" name="check" size="xs" class="mr-1" />
                {{ option.label }}
            </template>
            <template #singlelabel="{ value }">
                <div class="multiselect-single-label">
                    {{ value.label }}
                </div>
            </template>
        </MultiSelect>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const modelValue = defineModel()

const props = defineProps({
    paramsSearchFormNights: {
        type: Array,
        default: null
    }
})

const defaultNights = []

for (let n = 1; n <= 28; n++) {
    defaultNights.push(n)
}

const hasAvailableNights = computed(() => Array.isArray(props.paramsSearchFormNights) && props.paramsSearchFormNights.length > 0)

const options = computed(() => {
    const nights = hasAvailableNights.value ? props.paramsSearchFormNights : defaultNights

    return nights.map((nightsCount) => {
        const value = Number(nightsCount)
        return {
            value,
            label: t('nights', value)
        }
    })
})

const multiSelect = ref(null)
const root = ref(null)

const open = () => {
    if (multiSelect.value) {
        multiSelect.value.open()
    }
}

const scrollIntoView = () => {
    root.value?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}

defineExpose({ open, scrollIntoView })
</script>
